<template>
  <v-card flat v-bind="$attrs" v-on="$listeners" :loading="loading">
    <div class="text-center" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-form @submit.prevent="onSubmit" v-if="!loading" v-model="validUsernameForm">
      <v-container>
        <ApiError :errors="errors" />
        <v-alert border="top" type="info">
          To change your username, enter a new username.
        </v-alert>
        <v-row class="mt-3">
          <v-col cols="12">
            <EmailField
              v-if="usernameIsAnEmail"
              dense
              label="New Username"
              name="newUsername"
              id="newUsername"
              v-model="usernameForm.newUsername"
              :rules="rules.username"
            />
            <v-text-field
              v-else
              dense
              label="New Username"
              name="newUsername"
              id="newUsername"
              v-model="usernameForm.newUsername"
              :rules="rules.username"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn type="submit" color="primary" :disabled="!validUsernameForm || !usernameForm.newUsername">{{
              $i18n.translate("Change Username")
            }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-dialog v-model="isUpdateInfoDialog" max-width="650px">
      <v-card>
        <v-card-title>
          <span class="headline">Are you sure you want to change username?</span>
        </v-card-title>

        <v-card-text>
          <p>
            You are about to change your username.
            {{
              $privilege.isImpersonating() ? "Your impersonation will be stopped." : "Your account will be logged out."
            }}
          </p>
          <p v-if="!$privilege.isImpersonating() && usernameIsAnEmail">
            Please use your new username and email to log in.
          </p>
        </v-card-text>

        <v-card-actions align="center">
          <v-spacer />
          <v-btn @click="isUpdateInfoDialog = false">{{ $i18n.translate("Cancel") }}</v-btn>
          <v-btn color="primary" @click="onUsernameChange">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiError from "@/gapp-components/components/display/ApiError.vue";
import EmailField from "@/gapp-components/components/fields/EmailField.vue";
import ApiService from "../../../services/api.service";
import ValidationService from "@/gapp-components/services/validation.service.js";
import { mapGetters } from "vuex";

export default {
  name: "ProfileUsernameTab",
  components: {
    ApiError,
    EmailField
  },
  data: () => ({
    usernameForm: {
      newUsername: ""
    },
    validUsernameForm: true,
    loading: false,
    errors: {},
    isUpdateInfoDialog: false
  }),
  methods: {
    onSubmit() {
      this.isUpdateInfoDialog = true;
    },
    onUsernameChange() {
      this.loading = true;
      this.errors = {};
      this.usernameForm.sendEmail = true;

      ApiService.post("/api/users/changeUsername", this.usernameForm)
        .then(() => {
          this.isUpdateInfoDialog = false;
          this.usernameForm = { newUsername: "" };
          if (this.$privilege.isImpersonating()) {
            this.$auth.stopImpersonation().then(() => {
              return this.$router.push({ name: "dashboard" }).catch(() => {});
            });
          } else {
            this.$store.dispatch("logout");
            this.$router.push({ name: "login" });
          }
        })
        .catch(error => {
          this.errors = ApiService.getErrorsFromResponse(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["selectedProgram"]),
    usernameIsAnEmail() {
      return this.selectedProgram?.programGroup?.usernameIsAnEmail === true;
    },
    rules() {
      if (this.usernameIsAnEmail) {
        return {
          username: [
            ValidationService.generateNotWhitespacesRule("User Name"),
            ...ValidationService.generateTextValidationRules("User Name", 100, true)
          ]
        };
      }
      return {
        username: [
          ValidationService.generateNotWhitespacesRule("User Name"),
          ...ValidationService.generateTextValidationRules("User Name", 100, true)
        ]
      };
    }
  }
};
</script>
